// extracted by mini-css-extract-plugin
export default {"swipe-hint-overlay":"swipeHintOverlay_swipe-hint-overlay__7tHk-","visible":"swipeHintOverlay_visible__0+I4M","swipe-animation":"swipeHintOverlay_swipe-animation__gyP-V"};